import * as _ from 'lodash';
import toastr from 'toastr';
import ApiService from '../../../service/apiService';
import logUtils from '../../../HelperMethods/LogUtils';
import { parseJSONStringToObject } from '../../../HelperMethods/UtilityFunctions';
import { types as appActionTypes } from '../../../actions/appActions';

export const types = {
  LOADING_ROLES: 'LOADING_ROLES',
  LOAD_ROLES_SUCCESSFULLY: 'LOAD_ROLES_SUCCESSFULLY',
  LOAD_ROLES_FAILED: 'LOAD_ROLES_FAILED',
  UPDATING_ROLE: 'UPDATING_ROLE',
  UPDATE_ROLE_SUCCESSFULLY: 'UPDATE_ROLE_SUCCESSFULLY',
  UPDATE_ROLE_FAILED: 'UPDATE_ROLE_FAILED',
  CREATING_ROLE: 'CREATING_ROLE',
  CREATE_ROLE_SUCCESSFULLY: 'CREATE_ROLE_SUCCESSFULLY',
  CREATE_ROLE_FAILED: 'CREATE_ROLE_FAILED',
  DELETING_ROLE: 'DELETING_ROLE',
  DELETE_ROLE_SUCCESSFULLY: 'DELETE_ROLE_SUCCESSFULLY',
  DELETE_ROLE_FAILED: 'DELETE_ROLE_FAILED',
};

export function loadRoles() {
  return async (dispatch) => {
    dispatch({ type: types.LOADING_ROLES });
    try {
      const response = await ApiService.getRoles();
      const roles = _.get(response, 'data.getRoles.items');
      roles.forEach((role) => {
        role.access = parseJSONStringToObject(role.access);
      });
      dispatch({ type: types.LOAD_ROLES_SUCCESSFULLY, roles });
    } catch (e) {
      logUtils.logError(e, 'Loading Roles Failed');
      dispatch({ type: types.LOAD_ROLES_FAILED });
    }
  };
}

export function updateRole(role) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATING_ROLE });
    try {
      const clonedRole = _.pick(role, ['id', 'name', 'access']);
      const response = await ApiService.updateRole(clonedRole);
      const updatedRole = _.get(response, 'data.updateRole');
      if (!updatedRole) throw new Error('Didnt receive updated role from api');
      updatedRole.access = parseJSONStringToObject(updatedRole.access);
      toastr.success('Role updated');
      dispatch({ type: types.UPDATE_ROLE_SUCCESSFULLY, role: updatedRole });
      dispatch({ type: appActionTypes.ROLE_UPDATED, roleObject: updatedRole });
    } catch (e) {
      logUtils.logError(e, 'Updating Role failed');
      dispatch({ type: types.UPDATE_ROLE_FAILED });
      throw e;
    }
  };
}

export function createRole(role) {
  return async (dispatch) => {
    dispatch({ type: types.CREATING_ROLE });
    try {
      const response = await ApiService.createRole(role);
      const createdRole = _.get(response, 'data.createRole');
      if (!createdRole) throw new Error('Role not created');
      createdRole.access = parseJSONStringToObject(createdRole.access);
      toastr.success('Role Created');
      dispatch({ type: types.CREATE_ROLE_SUCCESSFULLY, role: createdRole });
    } catch (e) {
      logUtils.logError(e, 'Role creation failed');
      dispatch({ type: types.CREATE_ROLE_FAILED });
      throw e;
    }
  };
}

export function onSubmitButtonClicked(role) {
  return async (dispatch) => {
    const clonedRole = _.clone(role);
    clonedRole.access = JSON.stringify(clonedRole.access);
    if (role.id) {
      await updateRole(clonedRole)(dispatch);
    } else {
      await createRole(clonedRole)(dispatch);
    }
  };
}

export function deleteRole({ id: roleId }) {
  return async (dispatch) => {
    dispatch({ type: types.DELETING_ROLE });
    try {
      const response = await ApiService.deleteRole(roleId);
      const deletedRoleId = _.get(response, 'data.deleteRole.id');
      if (roleId !== deletedRoleId) throw new Error('Role was not deleted');
      dispatch({ type: types.DELETE_ROLE_SUCCESSFULLY, roleId });
      toastr.success('Role Deleted');
    } catch (e) {
      logUtils.logError(e, 'Role deleting failed');
      dispatch({ type: types.DELETE_ROLE_FAILED });
    }
  };
}
